import React, { Component, memo } from 'react';
import isVariablesEqual from 'common/helpers/isVariablesEqual';

class PureViewComponent extends Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return !Boolean(
      isVariablesEqual(this.props, nextProps) &&
      isVariablesEqual(this.state, nextState) &&
      isVariablesEqual(this.context, nextContext)
    );
  }
}

export const withViewMemo = (Component, useContextValue = null) => {
  // eslint-disable-next-line
  const hasPropTypes = !!Component.propTypes;
  // eslint-disable-next-line
  const propKeys = hasPropTypes ? Object.keys(Component.propTypes) : null;
  const Wrapped = memo(
    props => {
      const context = useContextValue?.();
      return React.createElement(Component, { ...props, context });
    },
    (prevProps, nextProps) => {
      const propsChanged = hasPropTypes
        ? propKeys.some(key => !isVariablesEqual(prevProps[key], nextProps[key]))
        : !isVariablesEqual(prevProps, nextProps);
      const contextChanged = !isVariablesEqual(prevProps.context, nextProps.context);
      return !(propsChanged || contextChanged);
    }
  );
  Wrapped.displayName = `withViewMemo(${Component.displayName || Component.name || 'Component'})`;
  Wrapped.propTypes = Component.propTypes;
  Wrapped.defaultProps = Component.defaultProps;
  return Wrapped;
};

export default PureViewComponent;
